define("SuiteDB.SDBFooterLinks.SDBFooterLinks", [
  "Footer.View",
  "SiteSearch.Button.View",
  "Utils",
  "Header.View",
], function (FooterView, SiteSearchButton, Utils, HeaderView) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      var currentDeviceType = Utils.getDeviceType(); // ==

      var layout = container.getComponent("Layout");

      layout.addToViewContextDefinition(
        "MenuTree.Node.View",
        "name",
        "string",
        function (ctx) {
          var name = ctx.node.name !== "Cases" ? ctx.node.name : "";

          return name;
        }
      );

      layout.addToViewContextDefinition(
        "Header.Menu.MyAccount.View",
        "entries",
        "object",
        function (ctx) {
          var names = _.filter(ctx.entries, function (entry) {
            return entry.name !== "Cases";
          });

          return names;
        }
      );

      // using the 'Layout' component we add a new child view inside the 'Header' existing view
      // (there will be a DOM element with the HTML attribute data-view="Header.Logo")
      // more documentation of the Extensibility API in
      // https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
      HeaderView.prototype.getContext = _.wrap(
        HeaderView.prototype.getContext,
        function (fn) {
          var context = fn.apply(this, _.toArray(arguments).slice(1));
          context.showDesktopView = Utils.getDeviceType() == "desktop";
          return context;
        }
      );
      FooterView.prototype.getContext = _.wrap(
        FooterView.prototype.getContext,
        function (fn) {
          var context = fn.apply(this, _.toArray(arguments).slice(1));
          context.footerLinksFirstColumn =
            SC.CONFIGURATION.SDBFooterLinks.footerLinksFirstColumns;
          context.footerLinksSecondColumn =
            SC.CONFIGURATION.SDBFooterLinks.footerLinksSecondColumns;
          return context;
        }
      );

      _.extend(SiteSearchButton.prototype, {
        toggleSiteSearch: function toggleSiteSearch(ev) {
          ev && ev.preventDefault();

          // This add a class 'active' to change button color
          this.$('[data-action="show-itemsearcher"]').toggleClass("active");
          $(".search-modal").toggleClass("active");

          this.application.getLayout().trigger("toggleItemSearcher");
        },
        verifyShowSiteSearch: function verifyShowSiteSearch() {
          var hash = Backbone.history.getFragment() || "";
          hash =
            hash.indexOf("?") === -1
              ? hash
              : hash.substring(0, hash.indexOf("?"));
          var is_home = hash === "" || hash === "/";

          if (Utils.getDeviceType() !== "desktop" && is_home) {
            //this event is registered on the header and used on every change of url
            if (event.target.hasAttribute("class", "header-logo-image")) return;

            this.toggleSiteSearch(null, true);
          } else {
            this.$('[data-action="show-itemsearcher"]').removeClass("active");
            // This hide sitesearch when navigate
            this.application.getLayout().trigger("hideItemSearcher");
          }
        },
      });

      $(window).on(
        "resize",
        _.debounce(function () {
          var newDeviceType = Utils.getDeviceType();

          if (newDeviceType !== currentDeviceType) {
            currentDeviceType = newDeviceType;
            container.layout.renderChild("Header");
          }
        }, 300)
      );
    },
  };
});
